// import {RESTAURANTS} from "./restaurant-mock";
export class Restaurant {

  constructor(
    public $key : string,
    public restaurant: string,
    public address: string,
    public city: string,
    public state: string,
    public zip: string,
    public agreed: boolean,
    public edit : string,
    public isActive: boolean,
    public latitude: string,
    public longitude: string

  ){


  };

  static fromJsonList(array): Restaurant[]{

    return array.map(json => Restaurant.fromJson(json));

  }

   static fromJson({$key,restaurant,address,city,state,zip,agreed,edit,isActive,latitude,longitude }) : Restaurant {
    return new Restaurant($key,restaurant,address,city,state,zip,agreed,edit,isActive,latitude,longitude )
  }








}



// WEBPACK FOOTER //
// ./src/app/shared/model/restaurant.ts